module.exports = __webpack_public_path__ + "static/mp_thumb-443aa0f2001d18cd3a558a6611322aad.png";